import PortalsPage from './PortalsPage'

export default PortalsPage
// eslint-disable-next-line import/export
export * from './PortalsPage'
